import { useNavigate } from 'react-router-dom';
import './UserDetail.css';

/**
 * props:
 * - data
 * - onEditClick
 * - onStopClick
 * - onStartClick
 */
function formatUsd(value) {
    const number = Number(value);
    if (!Number.isFinite(number)) return '0.00';
    const prefix = number > 0 ? '+' : '';
    return `${prefix}${number.toFixed(2)} USDC`;
}

function vaultCell(user) {
    if (!user?.isCustody && user?.pnlMode !== 'daily')
        return '—';
    const pnl = Number(user.pnl != null ? user.pnl : user.custodyVault?.net || 0);
    const daily = user.pnlMode === 'daily';
    const deposited = Number(user.depositedUsdc);
    const tone = pnl > 0 ? 'text-success' : pnl < 0 ? 'text-danger' : 'text-muted';
    const title = daily
        ? `PnL de hoje versus ${Number(user.dayOpenUsdc || 0).toFixed(2)} USDC no começo do dia`
        : (Number.isFinite(deposited)
            ? `Versus ${deposited.toFixed(2)} USDC depositado em carteira`
            : `PnL realizado: lucros ${Number(user.custodyVault?.gained || 0).toFixed(2)} · perdas ${Number(user.custodyVault?.lost || 0).toFixed(2)}`);
    return (
        <span className={tone} title={title}>
            {formatUsd(pnl)}
        </span>
    );
}

function UserRow(props) {
    const navigate = useNavigate();

    function openUser() {
        navigate(`/users/${props.data.id}`);
    }

    return (
        <tr>
            <td>
                {
                    props.data.isActive
                    ? <svg className="icon icon-xs me-2" fill="green" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
                    : <svg className="icon icon-xs me-2" fill="red" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" /></svg>
                }
                <button type="button" className="user-row-name" title="Ver detalhes do usuário" onClick={openUser}>
                    {props.data.name}
                </button>
            </td>
            <td>
                {props.data.email}
                {
                    props.data.isCustody
                        ? <span className="badge bg-info ms-2">Custódia</span>
                        : <></>
                }
            </td>
            <td>
                {props.data.limit?.name || '—'}
            </td>
            <td>
                {
                    props.data.isCustody
                        ? `${Number(props.data.custodyUsdc || 0).toFixed(2)} USDC`
                        : '—'
                }
            </td>
            <td>
                {vaultCell(props.data)}
            </td>
            <td>
                {props.data.isCustody
                    ? (
                        <div className="d-flex flex-column gap-1">
                            <span>
                                {Number(props.data.fundPayable || 0).toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })} USDT
                            </span>
                            {props.data.fundPayout
                                ? <span className="badge bg-warning text-dark">Saque pedido</span>
                                : null}
                            <button
                                type="button"
                                className="btn btn-outline-success btn-xs"
                                disabled={props.payingFund || (!(Number(props.data.fundPayable) > 0) && !props.data.fundPayout)}
                                onClick={event => {
                                    event.stopPropagation();
                                    props.onMarkFundPaid(props.data);
                                }}
                            >
                                {props.payingFund ? 'Marcando...' : 'Marcar pago'}
                            </button>
                        </div>
                    )
                    : '—'}
            </td>
            <td>
                <button type="button" className="btn btn-info btn-xs ms-2" title="Ver detalhes" onClick={openUser}>
                    <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                        <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                    </svg>
                </button>
                <button id={"edit" + props.data.id} type="button" className="btn btn-secondary btn-xs ms-2" title="Edit this User" data-bs-toggle="modal" data-bs-target="#modalUser" onClick={props.onEditClick}>
                    <svg className="icon icon-xs" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                </button>
                {
                    props.data.isActive
                        ? <button id={"stop" + props.data.id} type="button" className="btn btn-danger btn-xs ms-2" title="Stop this User" onClick={props.onStopClick}>
                            <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z" clipRule="evenodd" />
                            </svg>
                        </button>
                        : <></>
                }
                {
                    !props.data.isActive
                        ? <button id={"start" + props.data.id} type="button" className="btn btn-success btn-xs ms-2" title="Start this User" onClick={props.onStartClick}>
                            <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                            </svg>
                        </button>
                        : <></>
                }
                {
                    !props.data.isActive
                        ? <button id={"delete" + props.data.id} type="button" className="btn btn-danger btn-xs ms-2" title="Delete this User" onClick={props.onDeleteClick}>
                            <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                        </button>
                        : <></>
                }
            </td>
        </tr>
    )
}

export default UserRow;
